import * as React from "react";
function XlIcon() {
    return React.createElement("path", { d: "M17.5001 32.4999V21.3781L6.5835 7.5H33.4166L22.5 21.3781V32.4999H17.5001ZM20 21.1538L29.1069 9.59396H10.8932L20 21.1538Z", fill: "currentColor" });
}
export default XlIcon;
//# sourceMappingURL=Xl.js.map